/** 
 * @type {InvestorAccountsFilter} 
 */ 
 const filter = { 
with: null, 
orderBy: null, 
ids: null, 
investor_ids: null, 
} 
 /** 
 * @returns {InvestorAccountsFilter} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(filter)); 
 } 



// WEBPACK FOOTER //
// ./resources/js/filters/InvestorAccountsFilter.js